import React from "react";
import { useNavigate } from "react-router-dom";
import { BackSvg } from "../../svgFile";
import AllMenu from "./AllMenu";
import { usePage } from "../../PageContext";

const CommonHeader = ({ count=0 }) => {
  const navigate = useNavigate();
    const { pageName } = usePage();
  return (
    <header className="d-xl-none d-block">
      <nav className="navbar navbar-expand-xl ">
        <div className="container">
          <div className="back-icon" onClick={() => navigate(-1)}>
            <BackSvg />
          </div>
          <div className="page-name">
            <h3 className="mb-0">{pageName}</h3>
          </div>
          <div className="d-flex align-items-center gap-2">
            <button
              className="navbar-toggler toggler-btn"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#mainMenu"
              aria-controls="mainMenu"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
          </div>

          <AllMenu count={count}/>
        </div>
      </nav>
        <div className="shape"></div>
    </header>

  );
};

export default CommonHeader;
